module.exports = __webpack_public_path__ + "media/images/premium/fujimaru-logo-0ddb63a8ec323804371a4e7a9fb6cecd.png";